import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductStartingAgesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductStartingAgesReducer.productStartingAgesFeatureKey]
);

export const getStaticDataProductStartingAgesFailure = createSelector(
  getStaticDataProductStartingAgesState,
  staticDataCountriesReducer.fromStaticDataProductStartingAgesReducer.getProductStartingAgesFailure
);

export const getStaticDataProductStartingAgesResponse = createSelector(
  getStaticDataProductStartingAgesState,
  staticDataCountriesReducer.fromStaticDataProductStartingAgesReducer.getProductStartingAgesResponse
);

export const getStaticDataProductStartingAgesisLoaded = createSelector(
  getStaticDataProductStartingAgesState,
  staticDataCountriesReducer.fromStaticDataProductStartingAgesReducer.getProductStartingAgesIsLoaded
);
